import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-dm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-dm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { Validators } from "@angular/forms";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { ViewApplicationDetailsDmConstants } from "./view-application-details-dm.constants";
let ViewApplicationDetailsDmComponent = class ViewApplicationDetailsDmComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    routerParamsService;
    applicationTypeCtrl = ViewApplicationDetailsDmConstants.TYPE_CTRL;
    applicationTypeLbl = ViewApplicationDetailsDmConstants.TYPE_LBL;
    descriptionCtrl = ViewApplicationDetailsDmConstants.DESCRIPTION_CTRL;
    descriptionLbl = ViewApplicationDetailsDmConstants.DESCRIPTION_LBL;
    validationMessages = ViewApplicationDetailsDmConstants.VALIDATION_MESSAGES;
    applicationTypePlaceHolder = ViewApplicationDetailsDmConstants.APPLICATION_PLACE_HOLDER;
    applicationTypes = [];
    detailsForm;
    title = "";
    descriptionVisible = true;
    descriptionRequired = true;
    showApplicationType = true;
    applicationTypeRequired = true;
    getLookupsObservableSubscription;
    selectedApplicationPFSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.getMetadata();
    }
    ngOnInit() {
        this.loadLookup();
        this.initForm();
        this.getMetadata();
        this.populateForm(this.selectedApplication);
        this.subscribeToSelectedApplication();
    }
    handleRouteChange() {
    }
    loadMetadata(stepMeta) {
        if (stepMeta && stepMeta.hasOwnProperty("fieldSetup")) {
            const fieldSetup = stepMeta.fieldSetup;
            const descriptionOptions = fieldSetup.description;
            const typeOptions = fieldSetup.type;
            if (descriptionOptions) {
                const descriptionControl = this.detailsForm.get(this.descriptionCtrl);
                if (descriptionOptions.visible === false) {
                    descriptionControl.clearValidators();
                    this.descriptionRequired = false;
                    this.descriptionVisible = false;
                }
                else if (descriptionOptions.required === true) {
                    descriptionControl.setValidators(Validators.required);
                    this.descriptionRequired = true;
                    this.descriptionVisible = true;
                }
                else if (descriptionOptions.required === false) {
                    descriptionControl.clearValidators();
                    this.descriptionRequired = false;
                    this.descriptionVisible = true;
                }
                descriptionControl.updateValueAndValidity();
            }
            if (typeOptions) {
                const typeControl = this.detailsForm.get(this.applicationTypeCtrl);
                if (typeOptions.visible === false) {
                    typeControl.clearValidators();
                    this.applicationTypeRequired = false;
                    this.showApplicationType = false;
                }
                else if (typeOptions.required === true) {
                    typeControl.setValidators(Validators.required);
                    this.applicationTypeRequired = true;
                    this.showApplicationType = true;
                }
                else if (typeOptions.required === false) {
                    typeControl.clearValidators();
                    this.applicationTypeRequired = false;
                    this.showApplicationType = true;
                }
                typeControl.updateValueAndValidity();
            }
            this.detailsForm.updateValueAndValidity();
            this.changeDetectorRefs.detectChanges();
        }
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationPFSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.populateForm(application);
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm.enable();
    }
    populateForm(application) {
        if (application && application.appId > 0)
            this.detailsForm.markAsTouched();
        else
            return;
        this.detailsForm.get(this.applicationTypeCtrl).setValue(application.type);
        this.detailsForm.get(this.descriptionCtrl).setValue(application.description);
    }
    loadLookup() {
        this.getLookupsObservableSubscription = this.applicationViewService.getLookupsObservable({ $filter: `moduleId eq ${this.appController.selectedModuleID} and name eq 'ApplicationType' and deleted eq false` }).subscribe(lookupValues => {
            const lookup = lookupValues.value;
            lookup.forEach(lp => {
                this.applicationTypes.push(JSON.parse(lp.content));
            });
            this.changeDetectorRefs.detectChanges();
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsDmComponent = __decorate([
    Component({
        selector: "app-view-application-details-dm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsDmComponent);
export { ViewApplicationDetailsDmComponent };
